const ignore = () => undefined;

/**
 * Starts the signed-in app's larger independent modules alongside the app
 * itself. Each is evaluated in its own task as soon as its code arrives, rather
 * than inside one long task with the rest of the app, so the launch stays
 * responsive on slower phones. Every module listed is part of the signed-in app
 * anyway, so nothing extra is downloaded. A failed download is ignored here:
 * the app's own import reports it with the usual recovery screen.
 */
export function warmAppModules(signedInBefore: boolean) {
  void import("@/components/360/productivity/features").catch(ignore);
  void import("@/components/360/industries/useIndustry").catch(ignore);
  // The signed-in layout's data runtime; skipped before a first sign-in, when
  // the sign-in screen is all that loads.
  if (!signedInBefore) return;
  void import("@/components/360/api/lifecycle").catch(ignore);
  void import("@/components/360/api/CommsProvider").catch(ignore);
}

/** Someone used the app on this device before (cheap, synchronous hint). */
export function usedHere() {
  try {
    return Object.keys(localStorage).some((key) =>
      key.startsWith("360.workspace-cache:"),
    );
  } catch {
    return false;
  }
}
